import { TMargin } from '@libs/types';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';
import React from 'react';
import { getInlineStyles } from '../../utils/styles';
import { useLottieColorSlot } from './useLottieColorSlot';

export type TLottieAnimationViewProps = {
    uid?: string;
    animationsColor?: string;
    margin?: TMargin;
};

const logoStart = new URL('../../animations/LOGO_START.lottie', import.meta.url).href;

export const LoadingAnimationView = ({ uid, animationsColor, margin }: TLottieAnimationViewProps) => {
    const dotLottieRefCallback = useLottieColorSlot(animationsColor);

    return (
        <div data-test={uid ?? 'loader'} style={getInlineStyles({ margin, height: '73px', width: '73px' })}>
            <DotLottieReact src={logoStart} loop={false} autoplay dotLottieRefCallback={dotLottieRefCallback} />
        </div>
    );
};
